import NewsletterForm from "@/components/NewsletterForm";

const Newsletter = () => {
  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 mb-20">
      <div className="brutal-border brutal-shadow bg-card rounded-md p-8 sm:p-12 max-w-2xl mx-auto text-center">
        <h3 className="text-2xl font-black text-foreground tracking-tight mb-3">
          One framework every Tuesday.
        </h3>
        <p className="text-muted-foreground mb-6">
          No fluff. Just one actionable insight for founders building with AI.
        </p>
        <NewsletterForm utm_medium="homepage" />
      </div>
    </section>
  );
};

export default Newsletter;
